export default "__VITE_ASSET__CYTvX6yN__"